<div class="container padding-top-10 padding-bottom-10">
  <div class="col-xs-12">
    <div class="page-header">
      <h2 ng-show="newOcorrencia.id">Editando Ocorrência de Máquina</h2>
      <h2 ng-hide="newOcorrencia.id">Nova Ocorrência de Máquina</h2>
    </div>
    <ng-include src="'views/ocorrencias_maquinas/_form.html'"></ng-include>
  </div>
</div>